import { EditorState } from 'draft-js';
import { is } from 'immutable';

export default function isDirty(initialData, currentData) {
  if (currentData instanceof EditorState) {
    if (initialData) {
      return !is(initialData.getCurrentContent().getBlockMap(), currentData.getCurrentContent().getBlockMap());
    }

    return currentData.getCurrentContent().hasText();
  }

  if (initialData === undefined) {
    return currentData !== '' && currentData !== null && currentData !== undefined;
  }

  return !is(initialData, currentData);
}
